import { render, staticRenderFns } from "./CohortAccountList.vue?vue&type=template&id=5359bc4e&scoped=true&"
import script from "./CohortAccountList.vue?vue&type=script&lang=js&"
export * from "./CohortAccountList.vue?vue&type=script&lang=js&"
import style0 from "./CohortAccountList.vue?vue&type=style&index=0&id=5359bc4e&lang=scss&scoped=true&"
import style1 from "./CohortAccountList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5359bc4e",
  null
  
)

export default component.exports